import React, { Component } from "react";
import CardSingle from "./CardSingle";
import PropTypes from "prop-types";
import * as config from "config";
import { withWindowContext } from "context";

class Modules extends Component {
  // static propTypes = {
  //   modules: PropTypes.arrayOf(
  //     PropTypes.shape({
  //       name: PropTypes.string.isRequired,
  //       image: PropTypes.string,
  //       summary: PropTypes.string,
  //       url: PropTypes.string,
  //       type: PropTypes.string.isRequired,
  //       contentId: PropTypes.string.isRequired,
  //       status: PropTypes.number.isRequired,
  //       contentLength: PropTypes.number.isRequired,
  //       lastViewedPos: PropTypes.number.isRequired,
  //       maxViewedPos: PropTypes.number.isRequired,
  //       assignmentDate: PropTypes.instanceOf(Date).isRequired,
  //       completionDate: PropTypes.instanceOf(Date),
  //       nonAcademic: PropTypes.bool.isRequired,
  //     })
  //   ),
  //   selectedKey: PropTypes.string.isRequired,
  //   onSelect: PropTypes.func.isRequired,
  //   currentKey: PropTypes.string,
  //   onPlay: PropTypes.func.isRequired,
  //   noMaxHeight: PropTypes.bool.isRequired,
  //   preview: PropTypes.bool,
  //   chapterIndex:PropTypes.number,
  //   // cardIndex:PropTypes.number,
  // };

  onSelectModule = (m) => (command) => (e) => {
    this.props.preview && this.props.onSelect(m);
    const status = m.status;
    if (status !== config.contentStatusE.UNAVAILABLE) {
      this.props.onPlay(m)(command)(e);
    }
    if (m.type === "html" && m.playExt) {
      this.props.ctx_window.confirm({
        message:
          "This action will open the requested page in a new tab. Would you like to continue?",
        yesText: "Proceed",
        noText: "Cancel",
        callback: this.handleNewTab(m),
      });
    }
  };

  handleNewTab = (m) => (ok) => {
    this.props.onExtPlayConfirm(ok);
    if (ok) {
      var win = window.open(m.fileUrl ? m.fileUrl : config.ileUrl, "_blank");
      if (win) {
        //Browser has allowed it to be opened
        win.focus();
      } else {
        //Browser has blocked it
      }
    }
  };

  handleSequenceChange = (newSeq, modId, cardIndex, parentId, modIdx) => {
    // console.log(newSeq, modId, cardIndex, parentId, modIdx)
      this.props.onSequence(newSeq, modId, cardIndex, parentId, modIdx)
  }

  render = () => {
    const modules = this.props.modules.sort((a, b) => a.sequence - b.sequence)
    return this.props.modules && 
    // this.props.modules.sort((a, b) => a.sequence - b.sequence)
    modules.map((m, 
      modIdx) => {
      // if (!m.nonAcademic) {
      //   lastAcadMod = m.status;
      // }
      const selectedKey = this.props.activeEntityDetails
        ? this.props.activeEntityDetails.type === "module"
          ? this.props.activeEntityDetails.id
          : this.props.activeEntityDetails.type === "test" 
          ? this.props.activeEntityDetails.id
          : this.props.activeEntityDetails.sectionId
        : null;
      const isCurrent = m.id === selectedKey;
      // const consumed = this.props.viewType=="C" ?
      //  this.props.data[0].course_chapter_details[0].l_is_consumed :true
      // let moduleActive =
      //     endDate < today
      //     ? false
      //     : m && m.nonAcademic && consumed
      //     ? true
      //     : !consumed ? false
      //     : m.assignmentDate >= today
      //     ? false
      //     : i==0 && this.props.chapterIndex== 0
      //     ? true
      //     : nextActive
      //     ? true
      //     : m.status === config.contentStatusE.COMPLETED ||
      //       m.status === config.contentStatusE.REVIEWING ||
      //       m.status === config.contentStatusE.IN_PROGRESS
      //     ? true
      //     : false;

      // if(endDate < today){
      //   nextActive = false
      // }
      // else if (this.props.playInOrder === 1) {
      //   if (m.nonAcademic) {
      //     if (lastAcadMod === null) {
      //       // nextActive = true;
      //     } else {
      //       nextActive =
      //         lastAcadMod === config.contentStatusE.COMPLETED ||
      //         lastAcadMod === config.contentStatusE.REVIEWING
      //           ? true
      //           : false;
      //     }
      //   } else {
      //     nextActive =
      //       m.status === config.contentStatusE.COMPLETED ||
      //       m.status === config.contentStatusE.REVIEWING
      //         ? true
      //         : false;
      //   }
      // }
      // const command =
      //   m.status === config.contentStatusE.UNAVAILABLE
      //     ? "non"
      //     : m.status === config.contentStatusE.COMPLETED
      //     ? "restart"
      //     : m.status === config.contentStatusE.REVIEWING
      //     ? "resume"
      //     : m.status === config.contentStatusE.IN_PROGRESS
      //     ? "resume"
      //     : "play";

      // if(this.props.previewMulti && this.props.chapterIndex !== 0 ){
      //   moduleActive = false;
      // }

      return (
        <CardSingle
        onSequences={(newSeq, modId, cardIndex, parentId)=>this.handleSequenceChange(newSeq, modId, cardIndex, parentId, modIdx)}
        onSeqButtonClick={this.props.onSeqButtonClick}
        canModify={this.props.canModify} 
          preview={this.props.preview}
          subscriptionPreview={this.props.subscriptionPreview}
          isCurrent={isCurrent}
          onClick={(e) => this.props.onSelectEntity(e, m.type, m)}
          key={modIdx}
          moduleActive={this.props.selectedEntity !== "chapter"}
          onDeleteEntity={this.props.onDeleteEntity}
          activeEntityDetails={this.props.activeEntityDetails}
          selectedEntity={this.props.selectedEntity}
          cardIndex={modIdx}
          modifiable = {this.props.modifiable}
          createdId = {this.props.createdId}
          createrId = {this.props.createrId}
          disabledMode= {this.props.disabledMode}
          chapterProgress = {this.props.chapterProgress}
          // deletedValues={this.props.deletedValues}
          {...m}
        />
      );
    })
  };
}

export default withWindowContext(Modules);
